import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import * as actions from './actions'
import mutations from './mutations'

Vue.use(Vuex);

const state = {
    api: process.env.VUE_APP_API_ENDPOINT, // Server API endpoint url
    cluster: process.env.VUE_APP_CLUSTER, // Cluster name defined in .env
    uuid: "", // uuid
    config: {}, // Cluster configuration
    lists: {}, // Lists used in selects or autocomple fields
    validation: false // It is true when form data are being validated
};

export default new Vuex.Store({
    state,
    getters,
    actions,
    mutations
})
